<div id="layout-wrapper">
    <app-topbar></app-topbar>
    <div class="layout-outlet">
        <router-outlet></router-outlet>
        <div *ngIf="logoFlag" class="row">
            <div class="col-sm-12">
                <span style="float: right;padding-bottom: 10px;font-size: 13px; font-weight: 400;font-family: 'Poppins' !important;">
                    Powered By
                    <img src="assets/images/atom-logo.svg" height="30" width="175px" style="padding-left: 10px;">
                </span>
            </div>
        </div>

    </div>

</div>